<div class="container">
  <div class="progress-container">
    @for (step of steps; track $index) {
      <div class="step" [class.current-or-completed]="step.currentOrCompleted"></div>
    }
  </div>
  @if (label()) {
    <div class="steps-container">
      <span class="text">{{ label() }}</span>
    </div>
  }
</div>
